import { useEffect, useContext } from 'react';

/* eslint frontbucket-patterns/no-new-emotion-styled: "warn" */
import styled from '@emotion/styled';
import { useSelector } from 'react-redux';

import { getCombinedBannerAndHorizontalNavHeight } from 'src/selectors/global-selectors';
import { BucketState } from 'src/types/state';

import { useConsentBanner } from '../navigation-provider';

import { SidebarContext } from './context';

// TODO add polyfill for position: sticky
// https://softwareteams.atlassian.net/browse/BBCDEV-10779
const Container = styled.div<{
  topOffset: number;
}>(props => ({
  display: 'flex',
  /* Changing this to 100% causes sticky header cells of panels to not work. */
  height: `calc(100vh - ${props.topOffset}px)`,
  justifyContent: 'flex-end',
  position: 'sticky',
  top: `${props.topOffset}px`,
}));

type SidebarPlaceholderProps = {
  isBeingRenderedInsideMobileNav: boolean;
};

// The mobile sidebar is not always rendered, so we need to trigger a re-render
// of the Sidebar component when this component becomes rendered
export const SidebarPlaceholder = ({
  isBeingRenderedInsideMobileNav,
}: SidebarPlaceholderProps) => {
  const sidebarContext = useContext(SidebarContext);
  const { consentBannerHeight } = useConsentBanner()[0];

  useEffect(() => {
    sidebarContext.renderSidebar();
    // intentionally empty useEffect deps to simulate componentDidMount
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const topOffset = useSelector((state: BucketState) =>
    getCombinedBannerAndHorizontalNavHeight(
      state,
      isBeingRenderedInsideMobileNav,
      consentBannerHeight
    )
  );

  return <Container id="bb-sidebar" topOffset={topOffset} />;
};
